import Button from 'react-bootstrap/Button'

import { formatUrl } from '@/utils/helpers'

import { TocType } from './GuidePage'

type Props = {
  toc: TocType
}

const GuideNav = ({ toc }: Props) => (
  <div className='d-flex flex-wrap gap-2 justify-content-center p-3 pt-0'>
    {toc.map(({ header, icon, rows }) => {
      const href = '#' + formatUrl(`${header}-${rows[0].heading}`)
      return (
        <Button
          className='align-items-center d-flex gap-2 link-button'
          href={href}
          key={header}
          variant='outline-primary'
        >
          <i className={icon} />
          {header}
        </Button>
      )
    })}
  </div>
)

export default GuideNav
